import { APIClient } from '@frontend/api-utils';

export class GroupSyncClient extends APIClient {
    public static readonly endpoint = '/group-api/v1';

    public static async postIoTSeed(accountId: string, iotId: string, body: { account_id: string }): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/seed`, body);
        return this.handleResponse(response);
    }
}
